module.exports = __webpack_public_path__ + "static/media/farming3.5fc4e15a.png";